"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
var Divider_1 = __importDefault(require("../Divider"));
var Typography_1 = require("../Typography");
exports.default = react_1.forwardRef(function DrawerOverlay(_a, ref) {
    var _b, _c;
    var _d = _a.actions, actions = _d === void 0 ? [] : _d, _e = _a.actionsFullWidth, actionsFullWidth = _e === void 0 ? false : _e, _f = _a.anchor, anchor = _f === void 0 ? 'right' : _f, _g = _a.disableBackdropClick, disableBackdropClick = _g === void 0 ? false : _g, _h = _a.disableEscapeKeyDown, disableEscapeKeyDown = _h === void 0 ? false : _h, header = _a.header, _j = _a.hideBackdrop, hideBackdrop = _j === void 0 ? false : _j, _k = _a.justifyActions, justifyActions = _k === void 0 ? 'end' : _k, onClose = _a.onClose, open = _a.open, scrolled = _a.scrolled, _l = _a.padding, padding = _l === void 0 ? 'md' : _l, _m = _a.size, size = _m === void 0 ? 'md' : _m, title = _a.title, children = _a.children, restDrawerProps = __rest(_a, ["actions", "actionsFullWidth", "anchor", "disableBackdropClick", "disableEscapeKeyDown", "header", "hideBackdrop", "justifyActions", "onClose", "open", "scrolled", "padding", "size", "title", "children"]);
    var modalProps = { disableBackdropClick: disableBackdropClick, disableEscapeKeyDown: disableEscapeKeyDown, hideBackdrop: hideBackdrop };
    var classes = useStyles();
    var isVertical = ['top', 'bottom'].includes(anchor);
    return (jsx_runtime_1.jsxs(Drawer_1.default, __assign({ anchor: anchor, open: open, onClose: onClose, classes: { paper: clsx_1.default(classes["paper_" + size + "_" + (isVertical ? 'h' : 'w')], classes.paper) }, ModalProps: modalProps }, restDrawerProps, { ref: ref }, { children: [scrolled === false && jsx_runtime_1.jsx("div", { className: classes.appBarHeight }, void 0),
            jsx_runtime_1.jsx("div", __assign({ className: classes.drawerHeader }, { children: title ? jsx_runtime_1.jsx(Typography_1.H6, { children: title }, void 0) : header }), void 0),
            jsx_runtime_1.jsx(Divider_1.default, {}, void 0),
            jsx_runtime_1.jsx("div", __assign({ className: clsx_1.default(classes.drawerContent, (_b = {},
                    _b[classes.contentPaddingSm] = padding === 'sm',
                    _b[classes.contentPaddingMd] = padding === 'md',
                    _b[classes.contentPaddingLg] = padding === 'lg',
                    _b)) }, { children: children }), void 0),
            actions.length > 0 && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Divider_1.default, {}, void 0),
                    jsx_runtime_1.jsx("div", __assign({ className: clsx_1.default(classes.actions, (_c = {},
                            _c[classes.justifyActionsStart] = justifyActions === 'start',
                            _c)) }, { children: actions.map(function (_a) {
                            var _b;
                            var key = _a.key, node = _a.node;
                            return (jsx_runtime_1.jsx("div", __assign({ className: clsx_1.default(classes.actionItem, (_b = {},
                                    _b[classes.actionItemFullWidth] = actionsFullWidth === true,
                                    _b)) }, { children: node }), key));
                        }) }), void 0)] }, void 0))] }), void 0));
});
var paperViewportSizes = {
    xs: '20',
    sm: '30',
    md: '50',
    lg: '66',
    xl: '80',
};
var useStyles = styles_1.makeStyles(function (theme) {
    var _a;
    var mobileMediaQueryKey = theme.breakpoints.down('xs');
    var tabletMediaQueryKey = theme.breakpoints.down('md');
    var borderRadius = theme.shape.borderRadius + "px";
    return __assign(__assign({ paper: (_a = {},
            _a[mobileMediaQueryKey] = {
                borderRadius: borderRadius + " " + borderRadius + " 0 0",
                height: "calc(100% - 10px)",
                top: '10px',
                boxShadow: theme.shadows[4],
            },
            _a), appBarHeight: __assign({}, theme.mixins.toolbar), drawerHeader: __assign(__assign({ display: 'flex', alignItems: 'center', padding: theme.spacing(0, 2) }, theme.mixins.toolbar), { justifyContent: 'flex-start' }), drawerContent: {
            flexGrow: 2,
            // necessary for fixing the bottom bar with action buttons
            overflow: 'auto',
        }, actions: {
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 1,
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            padding: theme.spacing(2),
        }, actionItemFullWidth: { width: '100%' }, justifyActionsStart: {
            justifyContent: 'flex-start',
        }, actionItem: {
            padding: theme.spacing(0, 1),
        } }, Object.fromEntries(['Sm', 'Md', 'Lg'].map(function (size, i) { return [
        "contentPadding" + size,
        { padding: theme.spacing((i + 1) * 2, (i + 1) * 2 + 1) },
    ]; }))), Object.entries(paperViewportSizes).reduce(function (acc, _a) {
        var _b, _c, _d;
        var key = _a[0], size = _a[1];
        return (__assign(__assign({}, acc), (_b = {},
            _b["paper_" + key + "_h"] = { height: size + "vh" },
            _b["paper_" + key + "_w"] = { width: size + "vw" },
            _b[tabletMediaQueryKey] = __assign(__assign({}, acc[tabletMediaQueryKey]), (_c = {}, _c["paper_" + key + "_h"] = { height: '75vh !important' }, _c["paper_" + key + "_w"] = { width: '75vw !important' }, _c)),
            _b[mobileMediaQueryKey] = __assign(__assign({}, acc[mobileMediaQueryKey]), (_d = {}, _d["paper_" + key + "_h"] = { height: '100% !important' }, _d["paper_" + key + "_w"] = { width: '100% !important' }, _d)),
            _b)));
    }, {
        paper_auto_h: { height: 'auto' },
        paper_auto_w: { width: 'auto' },
    }));
});
//# sourceMappingURL=DrawerOverlay.js.map